import React from "react";
import {
  LayoutDashboard, Building2, Users, Network, Briefcase, SlidersHorizontal,
  Columns3, ListChecks, Search, Bell, Plus, SquarePen, Trash2, Check, X,
  TriangleAlert, Info, ChevronRight, ChevronDown, ChevronLeft, Download,
  ArrowRight, Settings, Filter, Calendar, Star, TrendingUp, MoreHorizontal,
  Lock, Globe, Phone, Mail, MapPin, CircleCheck, Clock, Play, Brain, Shield,
  Zap, Factory, Command, FileText, Sparkles, Eye, Circle,
  ArrowUp, ArrowDown, ChevronUp, Minus, Pin, Workflow, ArrowLeftRight, LayoutTemplate, PersonStanding,
} from "lucide-react";

/* ============================================================
   Talention — iconos compartidos

   El Design System manda lucide con trazo de ~2px. Este componente
   traduce el nombre en string al componente de lucide correspondiente,
   en vez de dibujar los paths a mano como hacía antes.

   Se mantiene la API <Icon name="..." /> porque 19 de los 78 usos pasan
   el nombre de forma dinámica desde estructuras de datos (NAV, grupos de
   factores, notificaciones, módulos de permisos), donde el icono viaja
   como string. Importar lucide directamente en cada sitio obligaría a
   convertir esas estructuras a referencias de componente.
   ============================================================ */

const MAP = {
  dashboard: LayoutDashboard,
  building: Building2,
  users: Users,
  tree: Network,
  briefcase: Briefcase,
  sliders: SlidersHorizontal,
  scale: Columns3,
  "check-list": ListChecks,
  search: Search,
  bell: Bell,
  plus: Plus,
  edit: SquarePen,
  trash: Trash2,
  check: Check,
  x: X,
  alert: TriangleAlert,
  info: Info,
  "chevron-right": ChevronRight,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  download: Download,
  "arrow-right": ArrowRight,
  settings: Settings,
  filter: Filter,
  calendar: Calendar,
  star: Star,
  "trend-up": TrendingUp,
  more: MoreHorizontal,
  lock: Lock,
  globe: Globe,
  phone: Phone,
  mail: Mail,
  map: MapPin,
  "circle-check": CircleCheck,
  clock: Clock,
  play: Play,
  brain: Brain,
  shield: Shield,
  zap: Zap,
  factory: Factory,
  command: Command,
  "file-text": FileText,
  sparkle: Sparkles,
  eye: Eye,

  // SVPT embebido (prototipo de evaluacion de puestos)
  "arrow-up": ArrowUp,
  "arrow-down": ArrowDown,
  "chevron-up": ChevronUp,
  minus: Minus,
  pin: Pin,
  sitemap: Workflow,
  swap: ArrowLeftRight,
  template: LayoutTemplate,
  gender: PersonStanding,   // lucide 0.460 no trae Venus/Mars
};

const Icon = ({ name, size = 18, className = "", style }) => {
  const Glyph = MAP[name] || Circle;
  return (
    <Glyph
      size={size}
      strokeWidth={2}
      className={"icon-svg " + className}
      style={style}
    />
  );
};

export default Icon;
export { Icon };
